import type { DiagnosisFlowStep, DiagnosisFlowStepState } from "./DiagnosisFlowSteps";

// 画面上部のステップチップの短い呼び名。登録・投資力診断・投資スタイル診断・プランナー紹介の各画面で表記がずれないよう1か所で持つ
export const DIAGNOSIS_STEP_CHIP_LABELS = {
  investment: "投資力診断",
  style: "スタイル診断",
  planner: "プランナー",
} as const;

// 登録導線の3段階カードの項目名と説明。
// 登録のはじめ・登録完了・投資スタイル診断の完了・3段階目の入口の4画面で文言を共通化する。
// 見出し・説明は Figma の SU-02 にそろえ、3段階目に「重要」バッジを付ける。
export const DIAGNOSIS_FLOW_STEP_DEFINITIONS: readonly Pick<DiagnosisFlowStep, "title" | "description" | "badge">[] = [
  {
    title: "投資力診断",
    description: "年収や属性から、そもそも投資できるか・無理のない投資金額が分かります",
  },
  {
    title: "あなたの投資スタイル診断書を作成",
    description: "どんな物件・どんな増やし方が向いているかが分かります",
  },
  {
    title: "認定プランナーとマッチ",
    badge: "重要",
    description: "あなたの要望に特化した認定プランナーを選びましょう",
  },
];

export type DiagnosisFlowStepStates = readonly [DiagnosisFlowStepState, DiagnosisFlowStepState, DiagnosisFlowStepState];

export const buildDiagnosisFlowSteps = (
  states: DiagnosisFlowStepStates,
  context: "registration" | "diagnosis" = "registration"
): DiagnosisFlowStep[] =>
  DIAGNOSIS_FLOW_STEP_DEFINITIONS.map((step, index) => ({
    ...step,
    // 診断側で「重要」バッジを省く既存の表示は維持し、文言は同じ定義を使う。
    ...(context === "diagnosis" && index === 2 ? { badge: undefined } : {}),
    state: states[index],
  }));
